import {
  ADD_DEMAND_FAIL,
  ADD_DEMAND_START,
  ADD_DEMAND_SUCCESS,
  DELETE_DEMAND_FAIL,
  DELETE_DEMAND_START,
  DELETE_DEMAND_SUCCESS,
  GET_DEMANDS,
  GET_DEMANDS_FAIL,
  SET_LOADING_STATUS,
} from '../Actions/actionTypes';

export const initState = {
  demands: [],
  loading: false,
  error: null,
  deleteDemand: { error: null, loading: false },
};

const articleReducer = (state = initState, action) => {
  switch (action.type) {
    case GET_DEMANDS:
      return { ...state, demands: action.payload, error: null };
    case GET_DEMANDS_FAIL:
      return { ...state, error: action.payload, loading: false };
    case SET_LOADING_STATUS:
      return { ...state, loading: action.status };
    case ADD_DEMAND_START:
      return { ...state, loading: true, error: null };
    case ADD_DEMAND_SUCCESS:
      return { ...state, loading: false, error: false };
    case ADD_DEMAND_FAIL:
      return { ...state, loading: false, error: action.payload };
    case DELETE_DEMAND_START:
      return { ...state, deleteDemand: { error: null, loading: true } };
    case DELETE_DEMAND_SUCCESS:
      return {
        ...state,
        demands: state.demands.filter((demand) => demand.demand_id !== action.payload),
        deleteDemand: { error: false, loading: false },
      };
    case DELETE_DEMAND_FAIL:
      return { ...state, deleteDemand: { error: action.payload, loading: false } };
    default:
      return state;
  }
};

export default articleReducer;
